import { render, staticRenderFns } from "./filter-tiles.vue?vue&type=template&id=c1272fe4&"
import script from "./filter-tiles.vue?vue&type=script&lang=js&"
export * from "./filter-tiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports